<ng-container *ngIf="isDraggable">
  <div
    cdkDrag
    class="modal-content modal-overscrolling"
    (cdkDragMoved)="dragPositionBoundary($event)"
    cdkDragRootElement=".cdk-overlay-pane"
    #modalOverScrolling
    (mousedown)="setOnTop($event)">
    <div class="header-button">
      <span class="cdk-move-button" cdkDragHandle> </span>
      <span class="cdk-close-button">
        <button mat-icon-button (click)="closeCdk()">
          <mat-icon>close</mat-icon>
        </button>
      </span>
    </div>
    <div [ngStyle]="ngStyleValue">
      <ng-container *ngIf="contentType == 'string'">
        <div class="box">
          <div [innerHTML]="contentString"></div>
        </div>
      </ng-container>
      <ng-container *ngIf="contentType == 'template'">
        <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
      </ng-container>
      <ng-container *ngIf="contentType == 'component'" #component style="border: 1px solid red !important">
        <ng-container *ngComponentOutlet="contentComponent" [ngStyle]="ngStyleValue" style="border: 1px solid green !important">
        </ng-container>
      </ng-container>
    </div>
  </div>
</ng-container>

<div *ngIf="!isDraggable" class="modal-content modal-overscrolling" #modalOverScrolling [ngStyle]="ngStyleValue">
  <ng-container *ngIf="contentType == 'string'">
    <div class="box">
      <div [innerHTML]="contentString"></div>
    </div>
  </ng-container>
  <ng-container *ngIf="contentType == 'template'">
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  </ng-container>
  <ng-container *ngIf="contentType == 'component'" #component style="border: 1px solid red !important">
    <ng-container *ngComponentOutlet="contentComponent" [ngStyle]="ngStyleValue" style="border: 1px solid green !important"> </ng-container>
  </ng-container>
</div>
